import { render, staticRenderFns } from "./UcbFooterCash.vue?vue&type=template&id=1c864dee&scoped=true"
import script from "./UcbFooterCash.vue?vue&type=script&lang=ts"
export * from "./UcbFooterCash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c864dee",
  null
  
)

export default component.exports